import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface ChatHistory {
  name: string
  session_id: string
  user_input_datetime: string
}

interface UserState {
  token: string | null
  platformId: string | null
  platformNickname: string | null
  sessionId: string | null
  internalUser: string | null
  platform: string | null
  botType: string | null
  userName: string | null
  email: string | null
  chatHistory?: ChatHistory[]
  currentSession?: ChatHistory | null
  showInitialScreen?: boolean
}

const initialState: UserState = {
  token: null,
  platformId: null,
  platformNickname: null,
  sessionId: null,
  internalUser: 'false',
  platform: null,
  botType: null,
  userName: null,
  email: null,
  chatHistory: [],
  currentSession: null,
  showInitialScreen: true
}

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    changeToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload
    },
    changePlatformId: (state, action: PayloadAction<string | null>) => {
      state.platformId = action.payload
    },
    changePlatformNickname: (state, action: PayloadAction<string | null>) => {
      state.platformNickname = action.payload
    },
    changeSessionId: (state, action: PayloadAction<string | null>) => {
      state.sessionId = action.payload
      state.currentSession = state.chatHistory?.find(session => session.session_id === state.sessionId) ?? null
    },
    changeInternalUser: (state, action: PayloadAction<string | null>) => {
      state.internalUser = action.payload
    },
    changePlatform: (state, action: PayloadAction<string | null>) => {
      state.platform = action.payload
    },
    changeBotType: (state, action: PayloadAction<string | null>) => {
      state.botType = action.payload
    },
    changeUserName: (state, action: PayloadAction<string | null>) => {
      state.userName = action.payload
    },
    changeEmail: (state, action: PayloadAction<string | null>) => {
      state.email = action.payload
    },
    changeChatHistory: (state, action: PayloadAction<ChatHistory[] | undefined>) => {
      state.chatHistory = action.payload
      state.currentSession = state.chatHistory?.find(session => session.session_id === state.sessionId) ?? null
    },
    changeShowInitialScreen: (state, action: PayloadAction<boolean>) => {
      state.showInitialScreen = action.payload
    }
  }
})

export const { changeToken, changePlatformId, changePlatformNickname, changeSessionId, changeInternalUser, changePlatform, changeBotType, changeUserName, changeEmail, changeChatHistory, changeShowInitialScreen } = userReducer.actions

export default userReducer.reducer
